<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { i18nService } from '@accor/customer-vue-services'
import { getFooterHtml } from '@/services/aem'

const hostRef = ref<HTMLElement | null>(null)
const locale = computed(() => i18nService.getCurrentLocale())

onMounted(async () => {
  try {
    const html = await getFooterHtml(locale.value)

    if (!html || !hostRef.value) return

    hostRef.value.innerHTML = html

    // Scripts injectés via innerHTML ne s'exécutent pas — les ré-exécuter
    hostRef.value.querySelectorAll('script').forEach((oldScript) => {
      const newScript = document.createElement('script')
      Array.from(oldScript.attributes).forEach((attr) =>
        newScript.setAttribute(attr.name, attr.value)
      )
      newScript.textContent = oldScript.textContent
      oldScript.replaceWith(newScript)
    })
  } catch {
    // silent fail — footer is non-critical
  }
})
</script>

<template>
  <div ref="hostRef" class="account-footer-host" />
</template>

<style lang="scss">
.account-footer-host {
  border-top: 1px solid var(--ah-navigation-border);
}
</style>
